import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { delay, take, tap, timeout } from 'rxjs/operators';

import { AtoPort } from '../_classes/ato-port';
import { AvbAverbTempo } from '../_classes/avb-averb-tempo';
import { Comprovante } from '../_classes/comprovante-ponto';
import { DiaDoMes } from '../_classes/dia-do-mes';
import { Email } from '../_classes/email';
import { EnderecoEmail } from '../_classes/endereco-email';
import { EstatisticaAcesso } from '../_classes/estatistica-acesso';
import { Feriado } from '../_classes/feriado';
import { Filtro } from '../_classes/filtro';
import { FrqFrequenciaMes } from '../_classes/frq-frequencia-mes';
import { LogAcessoSistema } from '../_classes/log-acesso-sistema';
import { MensagemBanco } from '../_classes/mensagem-banco';
import { Parametro } from '../_classes/parametro';
import { Periodo } from '../_classes/periodo';
import { Ponto } from '../_classes/ponto';
import { Proad } from '../_classes/proad';
import { PublicaPort } from '../_classes/publica-port';
import { Retorno } from '../_classes/retorno';
import { SgrhCreditoDia } from '../_classes/sgrh-credito-dia';
import { SgrhCreditoHora } from '../_classes/sgrh-credito-hora';
import { Usuario } from '../_classes/usuario';
import { Util } from '../_classes/util';
import { VwTrt24DirfOpseTransporte } from '../_classes/vw-trt24-dirf-opse-transporte';
import { Afastamento } from './../_classes/afastamento';
import { AvaliacaoSistema } from './../_classes/avaliacao-sistema';
import { BeneficioServidor } from './../_classes/beneficio-servidor';
import { Carreira } from './../_classes/carreira';
import { CedulaC } from './../_classes/cedula-c';
import { ContaPessoal } from './../_classes/conta-pessoal';
import { Curriculo } from './../_classes/curriculo';
import { CurriculoGruposAq } from './../_classes/curriculo-grupos-aq';
import { Dependencia } from './../_classes/dependencia';
import { Documentos } from './../_classes/documentos';
import { ElogioPunicao } from './../_classes/elogio-punicao';
import { FrqBancoHoras } from './../_classes/frq-banco-horas';
import { Holerite } from './../_classes/holerite';
import { Localidade } from './../_classes/localidade';
import { LotacaoServidor } from './../_classes/lotacao-servidor';
import { Provimento } from './../_classes/provimento';
import { Retifica } from './../_classes/retifica';
import { Servidor } from './../_classes/servidor';
import { ServidorSrh2 } from './../_classes/servidor-srh2';
import { Sistema } from './../_classes/sistema';
import { TabFtSrv } from './../_classes/tab-ft-srv';
import { EnvService } from './env.service';

@Injectable({
  providedIn: 'root',
})
export class RestService {
  private readonly endpoint;

  private delay = 0;
  private timeout = 15000;

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  constructor(private http: HttpClient, private env: EnvService) {
    this.endpoint = this.env.apiUrl + '/';
  }

  private extractData(res: Response) {
    const body = res;
    return body || {};
  }

  getEstouNaRedeInterna() {
    // nao deveria ser get?
    return this.http
      .post<string>(
        this.endpoint + 'geral/public/estou-na-rede-do-trt',
        null,
        this.httpOptions
      )
      .pipe(
        tap(console.log),
        timeout(this.timeout),
        delay(this.delay),
        take(1)
      );
  }

  setAvaliacaoSistema(a: AvaliacaoSistema) {
    return this.http
      .post<AvaliacaoSistema>(
        this.endpoint + 'serv/avaliacao-sistema/',
        a,
        this.httpOptions
      )
      .pipe(timeout(this.timeout), delay(this.delay), take(1));
  }

  setLogAcessoSistema(a: LogAcessoSistema) {
    return this.http
      .post<LogAcessoSistema>(
        this.endpoint + 'serv/log-acesso-sistema/',
        a,
        this.httpOptions
      )
      .pipe(timeout(this.timeout), delay(this.delay), take(1));
  }

  setRamal(a: ServidorSrh2) {
    return this.http
      .post<ServidorSrh2>(this.endpoint + 'serv/ramal/', a, this.httpOptions)
      .pipe(timeout(this.timeout), delay(this.delay), take(1));
  }

  setFeedback(a: Email) {
    return this.http
      .post<Email>(this.endpoint + 'geral/email/feedback/', a, this.httpOptions)
      .pipe(timeout(this.timeout), delay(this.delay), take(1));
  }

  getServidorAcessoAutorizacao(
    nomeUsuario: string,
    chave: string
  ): Observable<Servidor> {
    // //console.log(this.endpoint);
    return this.http
      .get<Servidor>(this.endpoint + 'serv/' + nomeUsuario + '/acesso/' + chave)
      .pipe(
        timeout(this.timeout),
        delay(this.delay),
        //tap(console.log),
        take(1)
      );
  }

  getServidor(nomeUsuario: string): Observable<Servidor> {
    // //console.log(this.endpoint);
    //console.log('rest.getServidor()', this.endpoint + 'serv/' + nomeUsuario);
    return this.http
      .get<Servidor>(this.endpoint + 'serv/' + nomeUsuario)
      .pipe(
        timeout(this.timeout),
        delay(this.delay),
        tap(console.log),
        take(1)
      );
  }

  getIp(): Observable<String> {
    return this.http
      .get<String>(this.endpoint + 'geral/public/ip')
      .pipe(
        timeout(this.timeout),
        delay(this.delay),
        tap(console.log),
        take(1)
      );
  }

  pegarSomentePrimeiraMatricula(matricula: string): string {
    //console.log('matricula1/2:', matricula);
    let retorno: string = '';
    if (matricula) {
      if (matricula.search('/') > 0) {
        retorno = matricula.split('/')[0].trim();
      } else {
        retorno = matricula;
      }
    }
    //console.log('matricula2/2:', matricula);
    return retorno;
  }

  getServidorPelaMatricula(matricula: string): Observable<Servidor> {
    // //console.log(this.endpoint);
    return this.http
      .get<Servidor>(
        this.endpoint +
          'serv/servidor-pela-matricula/' +
          this.pegarSomentePrimeiraMatricula(matricula)
      )
      .pipe(
        timeout(this.timeout),
        delay(this.delay),
        tap(console.log),
        take(1)
      );
  }

  getAvaliacaoSistema(id: number): Observable<AvaliacaoSistema> {
    return this.http
      .get<AvaliacaoSistema>(
        this.endpoint + 'serv/' + id + '/avaliacao-sistema/0'
      )
      .pipe(
        timeout(this.timeout),
        delay(this.delay),
        tap(console.log),
        take(1)
      );
  }

  getMediaGeral(): Observable<string> {
    return this.http
      .get<string>(this.endpoint + 'serv/avaliacao-sistema/media')
      .pipe(
        timeout(this.timeout),
        delay(this.delay),
        tap(console.log),
        take(1)
      );
  }

  getServidorSrh2(matricula: string): Observable<ServidorSrh2> {
    //console.log('getServidorSrh2', matricula);
    return this.http
      .get<ServidorSrh2>(
        this.endpoint +
          'serv/servidor-srh2-pela-matricula/' +
          this.pegarSomentePrimeiraMatricula(matricula)
      )
      .pipe(
        timeout(this.timeout),
        delay(this.delay),
        // tap(console.log),
        take(1)
      );
  }

  getParametro(dsChave: string): Observable<Parametro> {
    return this.http
      .get<Parametro>(this.endpoint + 'geral/parametro/' + dsChave)
      .pipe(
        timeout(this.timeout),
        delay(this.delay),
        tap(console.log),
        take(1)
      );
  }

  getParametro2(dsChave: string) {
    return this.http
      .get<Parametro>(this.endpoint + 'geral/parametro/' + dsChave)
      .pipe(
        timeout(this.timeout),
        delay(this.delay),
        tap(console.log),
        take(1)
      );
  }

  listarDirfOpseTransporte(id: number) {
    //console.log('Listar lancamentos que nÃ£o foram na DIRF');
    return this.http
      .get<VwTrt24DirfOpseTransporte[]>(
        this.endpoint + 'serv/' + id + '/operadora-ans'
        //this.endpoint + 'serv/1236/operadora-ans'
      )
      .pipe(timeout(this.timeout), delay(this.delay), take(1));
  }

  listarServidorSrh2(str: string) {
    return this.http
      .get<ServidorSrh2[]>(
        this.endpoint + 'serv/me-encontre/s/' + str.toUpperCase()
      )
      .pipe(
        timeout(this.timeout),
        delay(this.delay),
        tap(console.log),
        take(1)
      );
  }

  listarComFiltro(filtro: Filtro[], tipo: string): Observable<[]> {
    //console.log('listar-filtro', filtro, tipo);
    return this.http
      .post<Filtro[]>(
        this.endpoint + tipo + '/listar-filtro',
        filtro,
        this.httpOptions
      )
      .pipe(
        tap(console.log),
        timeout(this.timeout),
        delay(this.delay),
        take(1)
      );
  }

  listarSistema() {
    //console.log('vou chamar listarSistema');
    return this.http
      .get<Sistema[]>(this.endpoint + 'geral/sistemas/0')
      .pipe(
        timeout(this.timeout),
        delay(this.delay),
        tap(console.log),
        take(1)
      );
  }

  listarServidorSrh2DaLocalidade(str: string) {
    return this.http
      .get<ServidorSrh2[]>(
        this.endpoint + 'serv/me-encontre/sl/' + str.toUpperCase()
      )
      .pipe(
        timeout(this.timeout),
        delay(this.delay),
        tap(console.log),
        take(1)
      );
  }

  listarLocalidade(str: string) {
    return this.http
      .get<Localidade[]>(
        this.endpoint + 'serv/me-encontre/l/' + str.toUpperCase()
      )
      .pipe(
        timeout(this.timeout),
        delay(this.delay),
        tap(console.log),
        take(1)
      );
  }

  listarFrqBancoHoras(matricula: string) {
    return this.http
      .get<FrqBancoHoras[]>(
        this.endpoint + 'serv/' + matricula + '/banco-horas/0'
      )
      .pipe(
        timeout(this.timeout),
        delay(this.delay),
        tap(console.log),
        take(1)
      );
  }
  /*
  listarFrqBancoHoras(id: number) {
    console.log(
      'chamar BancoDeHoras',
      this.endpoint + 'serv/' + id + '/banco-horas/0'
    );

    return this.http
      .get<FrqBancoHoras[]>(this.endpoint + 'serv/' + id + '/banco-horas/0')
      .pipe(
        timeout(this.timeout),
        delay(this.delay),
        tap(console.log),
        take(1)
      );
  }*/

  getContaCorrente(idServidor: number) {
    // lembrar que o modo de chamada Ã© diferente
    return this.http
      .get<ContaPessoal>(
        this.endpoint + 'serv/' + idServidor + '/conta-corrente/-1'
      )
      .pipe(
        timeout(this.timeout),
        delay(this.delay),
        tap(console.log),
        take(1)
      );
  }

  getContaPessoal(idServidor: number, id: number) {
    //console.log("rest - idServidor: " + idServidor + "id: " + id);
    return this.http
      .get<ContaPessoal[]>(
        this.endpoint + 'serv/' + idServidor + '/conta/' + id
      )
      .pipe(
        timeout(this.timeout),
        delay(this.delay),
        tap(console.log),
        take(1)
      );
  }

  listarContaPessoal(id: number) {
    return this.http
      .get<ContaPessoal[]>(this.endpoint + 'serv/' + id + '/conta/0')
      .pipe(timeout(this.timeout), delay(this.delay), take(1));
  }

  getQuantidadeHoleriteNovo(matricula: string): Observable<number> {
    // lembrar que o modo de chamada Ã© diferente
    return this.http
      .get<number>(
        this.endpoint +
          'serv/' +
          this.pegarSomentePrimeiraMatricula(matricula) +
          '/holerite-novo-qtde/'
      )
      .pipe(
        timeout(this.timeout),
        delay(this.delay),
        tap(console.log),
        take(1)
      );
  }
  /*
  getQuantidadeSiateAberto(dsUsuario: string): Observable<number> {
    // lembrar que o modo de chamada eh diferente - /serv/siate-aberto-qtde/{usuario}
    return this.http
      .get<number>(this.endpoint + 'serv/siate-aberto-qtde/' + dsUsuario)
      .pipe(
        timeout(this.timeout),
        delay(this.delay),
        tap(console.log),
        take(1)
      );
  }*/

  getQuantidadeEmailsNaoLidos(u: Usuario): Observable<number> {
    /*
    return this.http
      .get<number>(
        this.endpoint + 'serv/' + u.idUsuario + '/email-novo-qtde/' + u.dsSenha
      )
      .pipe(
        timeout(this.timeout),
        delay(this.delay),
        tap(console.log),
        take(1)
      );*/
    return this.http
      .post<Usuario>(this.endpoint + 'serv/email-novo-qtde/', u)
      .pipe(
        timeout(this.timeout),
        delay(this.delay),
        tap(console.log),
        take(1)
      );
  }

  listarHolerite(idServidor: number) {
    console.log('Vou listar holerit');
    return this.http
      .get<Holerite[]>(this.endpoint + 'serv/' + idServidor + '/holerite/0')
      .pipe(
        timeout(this.timeout*2),
        //delay(this.delay),
        tap(console.log),
        take(1)
      );
  }
  /*
  listarSiate(idServidor: number) {
    return this.http
      .get<SiateTicket[]>(this.endpoint + 'serv/' + idServidor + '/siate')
      .pipe(
        timeout(this.timeout * 3),
        delay(this.delay),
        tap(console.log),
        take(1)
      );
  }

  getDocumentoComBlob(id: number) {
    return this.http
      .get<Holerite[]>(this.endpoint + 'geral/documento/' + id)
      .pipe(
        timeout(this.timeout),
        delay(this.delay),
        tap(console.log),
        take(1)
      );
  }*/

  getPublicacaoComBlob(id: number) {
    return this.http
      .get<AtoPort[]>(this.endpoint + 'geral/public/documento/c/' + id)
      .pipe(
        timeout(this.timeout),
        delay(this.delay),
        tap(console.log),
        take(1)
      );
  }

  getFoto(id: string) {
    return this.http
      .get<TabFtSrv[]>(this.endpoint + 'geral/foto/' + id)
      .pipe(
        timeout(this.timeout),
        delay(this.delay),
        tap(console.log),
        take(1)
      );
  }

  getComprovantePonto(id: number) {
    return this.http
      .get<Comprovante>(this.endpoint + 'serv/comprovante-ponto/' + id)
      .pipe(timeout(this.timeout), delay(this.delay), take(1));
  }

  getHolerite(idServidor: number, h: Holerite) {
    return this.http
      .get<Holerite[]>(
        this.endpoint +
          'serv/' +
          idServidor +
          '/holerite/' +
          h.base +
          '.' +
          h.id
      )
      .pipe(
        timeout(this.timeout*2),
        //delay(this.delay),
        tap(console.log),
        take(1)
      );
  }

  listarCurriculo(cpf: string): Observable<Curriculo[]> {
    return this.http
      .get<Curriculo[]>(this.endpoint + 'serv/' + cpf + '/curriculo/0')
      .pipe(
        timeout(this.timeout),
        delay(this.delay),
        // tap((a: Curriculo[]) => a.data as Curriculo)
        take(1)
      );
  }

  listarCurriculoGruposAq(cpf: string): Observable<CurriculoGruposAq[]> {
    console.log(
      'filtro: ',
      this.endpoint + 'serv/' + cpf + '/curriculo-grupos-aq/0'
    );
    return this.http
      .get<CurriculoGruposAq[]>(
        this.endpoint + 'serv/' + cpf + '/curriculo-grupos-aq/0'
      )
      .pipe(
        timeout(this.timeout * 2),
        delay(this.delay),
        tap(console.log),
        take(1)
      );
  }

  listarCedulaC(idServidor: number): Observable<CedulaC[]> {
    return this.http
      .get<CedulaC[]>(this.endpoint + 'serv/' + idServidor + '/cedulac/0/0')
      .pipe(
        timeout(this.timeout),
        delay(this.delay),
        //tap(console.log()),
        take(1)
      );
  }

  getCedulaC(
    idServidor: number,
    id: number,
    tipoCedulaC: string
  ): Observable<CedulaC> {
    return this.http
      .get<CedulaC>(
        this.endpoint +
          'serv/' +
          idServidor +
          '/cedulac/' +
          id +
          '/' +
          tipoCedulaC
      )
      .pipe(
        timeout(this.timeout),
        delay(this.delay),
        // tap(console.log),
        take(1)
      );
  }

  getDocumento(id: number): Observable<Documentos> {
    return this.http.get<Documentos>(this.endpoint + 'geral/doc/' + id).pipe(
      timeout(this.timeout),
      delay(this.delay),
      // tap(console.log),
      take(1)
    );
  }

  // dependente
  listarDependencia(idServidor: number) {
    return this.http
      .get<Dependencia[]>(
        this.endpoint + 'serv/' + idServidor + '/dependencia/0'
      )
      .pipe(
        timeout(this.timeout),
        delay(this.delay),
        tap(console.log),
        take(1)
      );
  }

  // elogio
  listarElogioPunicao(idServidor: number) {
    return this.http
      .get<ElogioPunicao[]>(
        this.endpoint + 'serv/' + idServidor + '/elogio-punicao/0'
      )
      .pipe(
        timeout(this.timeout),
        delay(this.delay),
        tap(console.log),
        take(1)
      );
  }

  listarAverbacao(matricula: string) {
    return this.http
      .get<AvbAverbTempo[]>(
        this.endpoint +
          'serv/' +
          this.pegarSomentePrimeiraMatricula(matricula) +
          '/averbacao'
      )
      .pipe(
        timeout(this.timeout),
        delay(this.delay),
        tap(console.log),
        take(1)
      );
  }

  // evolucao-carreira
  listarCarreira(idServidor: number) {
    return this.http
      .get<Carreira[]>(this.endpoint + 'serv/' + idServidor + '/carreira/0')
      .pipe(
        timeout(this.timeout),
        delay(this.delay),
        tap(console.log),
        take(1)
      );
  }

  // provimento
  listarProvimento(idServidor: number) {
    return this.http
      .get<Provimento[]>(this.endpoint + 'serv/' + idServidor + '/provimento/0')
      .pipe(
        timeout(this.timeout),
        delay(this.delay),
        tap(console.log),
        take(1)
      );
  }

  listarProadPush(idUsuario: number, mostrarArquivados: number) {
    /*mostrarArquivados 1-SIM, 0-NÃƒO  */
    //console.log('listarProadPush','serv/' + idUsuario + '/proad-push/' + mostrarArquivados);
    return this.http
      .get<Proad[]>(
        this.endpoint + 'serv/' + idUsuario + '/proad-push/' + mostrarArquivados
      )
      .pipe(
        timeout(this.timeout),
        delay(this.delay),
        tap(console.log),
        take(1)
      );
  }

  listarEfeitos(ato: AtoPort, tipo: string): Observable<Retifica[]> {
    //tipo: S - sofridos, G - gerados, T - todos public/efeito/{id}/{tipo}
    return this.http
      .get<Retifica[]>(
        this.endpoint + 'geral/public/efeito/' + ato.idPort + '/' + tipo
      )
      .pipe(
        timeout(this.timeout),
        delay(this.delay),
        tap(console.log),
        take(1)
      );
  }

  // periodo-avaliativo
  listarPeriodoAvaliativo(idServidor: number) {
    return this.http
      .get<Carreira[]>(
        this.endpoint + 'serv/' + idServidor + '/periodo-avaliativo/0'
      )
      .pipe(
        timeout(this.timeout),
        delay(this.delay),
        tap(console.log),
        take(1)
      );
  }

  // lotacao
  listarLotacao(idServidor: number) {
    return this.http
      .get<LotacaoServidor[]>(
        this.endpoint + 'serv/' + idServidor + '/lotacao/0'
      )
      .pipe(
        timeout(this.timeout),
        delay(this.delay),
        tap(console.log),
        take(1)
      );
  }

  listarAfastamento(idServidor: number): Observable<Afastamento[]> {
    return this.http
      .get<Afastamento[]>(
        this.endpoint + 'serv/' + idServidor + '/afastamento/0'
      )
      .pipe(
        timeout(this.timeout),
        delay(this.delay * 100),
        tap(console.log),
        take(10)
      );
  }

  listarAfastamentoSetor(id: number): Observable<Afastamento[]> {
    return this.http
      .get<Afastamento[]>(this.endpoint + 'serv/' + id + '/afastamento-setor')
      .pipe(
        timeout(this.timeout),
        delay(this.delay),
        tap(console.log),
        take(10)
      );
  }

  listarBeneficio(idServidor: number): Observable<BeneficioServidor[]> {
    return this.http
      .get<BeneficioServidor[]>(
        this.endpoint + 'serv/' + idServidor + '/beneficio'
      )
      .pipe(timeout(this.timeout), delay(this.delay), take(1));
  }

  listarSgrhCreditoDia(idServidor: number): Observable<SgrhCreditoDia[]> {
    return this.http
      .get<SgrhCreditoDia[]>(
        this.endpoint + 'serv/' + idServidor + '/sgrh-credito-dia'
      )
      .pipe(timeout(this.timeout), delay(this.delay), take(1));
  }

  listarEnderecoEmail(tipo: string): Observable<EnderecoEmail[]> {
    return this.http
      .get<EnderecoEmail[]>(this.endpoint + 'geral/endereco-email/' + tipo)
      .pipe(timeout(this.timeout), delay(this.delay), take(1));
  }

  listarFeriadosGeral(dI: Date, dF: Date): Observable<Feriado[]> {
    // //console.log('Consulta de: ' + dI.toString() + ' atÃ© ' + dF.toString());
    if (!dI) {
      dI = new Date();
    }

    if (!dF) {
      dF = new Date(dI);
    }
    const pI: string = Util.dataParaRest(dI);
    const pF: string = Util.dataParaRest(dF);
    // //console.log('Consulta de: ' + pI.toString() + ' atÃ© ' + pF.toString());
    return this.http
      .get<Feriado[]>(this.endpoint + 'geral/public/feriado/' + pI + '/' + pF)
      .pipe(
        timeout(this.timeout),
        delay(this.delay),
        //tap(console.log),
        take(1)
      );
  }

  listarFeriadosMeus(dI: Date, dF: Date, mat: string): Observable<Feriado[]> {
    if (!dI) {
      dI = new Date();
    }

    if (!dF) {
      dF = new Date(dI);
    }
    const pI: string = Util.dataParaRest(dI);
    const pF: string = Util.dataParaRest(dF);
    return this.http
      .get<Feriado[]>(
        this.endpoint + 'serv/' + mat + '/feriado/' + pI + '/' + pF
      )
      .pipe(
        timeout(this.timeout),
        delay(this.delay),
        //tap(console.log),
        take(1)
      );
  }

  listarFrequencia(mat: string, mesAno: string): Observable<DiaDoMes[]> {
    return this.http
      .get<DiaDoMes[]>(this.endpoint + 'serv/' + mat + '/frequencia/' + mesAno)
      .pipe(
        timeout(this.timeout),
        delay(this.delay),
        //tap(console.log),
        take(1)
      );
  }

  listarPonto(cpf: string, pMesAno: string): Observable<Ponto[]> {
    //console.log('listarPonto', cpf, pMesAno);
    //"/{cpf}/ponto-listar/{mesAno}"
    return this.http
      .get<Ponto[]>(this.endpoint + 'serv/' + cpf + '/ponto-listar/' + pMesAno)
      .pipe(
        timeout(this.timeout),
        delay(this.delay),
        tap(console.log),
        take(1)
      );
  }

  getFrequenciaMes(mat: string, pAnoMes: string): Observable<FrqFrequenciaMes> {
    return this.http
      .get<FrqFrequenciaMes>(
        this.endpoint + 'serv/' + mat + '/frequencia-mes/' + pAnoMes
      )
      .pipe(
        timeout(this.timeout),
        delay(this.delay),
        tap(console.log),
        take(1)
      );
  }

  listarFeriadosTodos(): Observable<Feriado[]> {
    return this.http
      .get<Feriado[]>(this.endpoint + 'geral/public/feriado-todos/')
      .pipe(
        timeout(this.timeout),
        delay(this.delay),
        //tap(console.log),
        take(1)
      );
  }

  listarEstatisticaAcesso(): Observable<EstatisticaAcesso[]> {
    return this.http
      .get<EstatisticaAcesso[]>(this.endpoint + 'geral/recursos-estatistica')
      .pipe(timeout(this.timeout), delay(this.delay), take(1));
  }

  listarEstatisticaAcessoComPeriodo3(
    dtInicio: Date,
    dtFim: Date
  ): Observable<Retorno> {
    const pI: string = Util.dataParaRest(dtInicio);
    const pF: string = Util.dataParaRest(dtFim);
    return this.http
      .get<Retorno>(
        this.endpoint + 'geral/recursos-estatistica/' + pI + '/' + pF
      )
      .pipe(timeout(this.timeout), delay(this.delay), take(1));
  }

  listarEstatisticaAcessoComPeriodo(
    dtInicio: Date,
    dtFim: Date
  ): Observable<Retorno> {
    let datas: Periodo = new Periodo();
    datas.dtFinal = dtFim;
    datas.dtInicial = dtInicio;
    return this.http
      .post<Retorno>(
        this.endpoint + 'geral/recursos-estatistica',
        datas,
        this.httpOptions
      )
      .pipe(timeout(this.timeout * 10), delay(this.delay), take(1));
    /*
    return this.http
      .post<Retorno>(
        this.endpoint + 'geral/recursos-estatistica',
        datas,
        this.httpOptions
      )
      .pipe(timeout(this.timeout), delay(this.delay), take(1));*/
  }

  getQuantidadeSgrhCreditoDia(idServidor: number): Observable<number> {
    return this.http
      .get<number>(
        this.endpoint + 'serv/' + idServidor + '/sgrh-credito-dia-total'
      )
      .pipe(timeout(this.timeout), delay(this.delay), take(1));
  }

  getRespondeuRecadastramento(idServidor: number): Observable<boolean> {
    return this.http
      .get<boolean>(this.endpoint + 'serv/' + idServidor + '/recadastramento')
      .pipe(timeout(this.timeout), delay(this.delay), take(1));
  }

  getQuantidadeSgrhCreditoHora(idServidor: number): Observable<number> {
    return this.http
      .get<number>(
        this.endpoint + 'serv/' + idServidor + '/sgrh-credito-hora-total'
      )
      .pipe(timeout(this.timeout), delay(this.delay), take(1));
  }

  listarSgrhCreditoHora(idServidor: number): Observable<SgrhCreditoHora[]> {
    return this.http
      .get<SgrhCreditoHora[]>(
        this.endpoint + 'serv/' + idServidor + '/sgrh-credito-hora'
      )
      .pipe(timeout(this.timeout), delay(this.delay), take(1));
  }

  listarAtoPort(f: Filtro[]): Observable<AtoPort[]> {
    return this.http
      .post<AtoPort[]>(
        this.endpoint + 'geral/public/publicacoes/',
        f,
        this.httpOptions
      )
      .pipe(timeout(this.timeout * 10), delay(this.delay), take(1));
  }

  listarOndePublicou(id: number): Observable<PublicaPort[]> {
    return this.http
      .get<PublicaPort[]>(this.endpoint + 'geral/public/publicacoes/' + id)
      .pipe(timeout(this.timeout), delay(this.delay), take(1));
  }

  listarMensagensNaoLidas(id: number): Observable<MensagemBanco[]> {
    //console.log('chamado procedimento listarMensagensNaoLidas');
    return this.http
      .get<MensagemBanco[]>(this.endpoint + 'serv/' + id + '/mensagem')
      .pipe(
        timeout(this.timeout),
        delay(this.delay),
        tap(console.log),
        take(1)
      );
  }

  handleError(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Código: ${error.status}\nMensagem: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }
}
